export const CalendarController = {
    index(): void {},
    eventsByMonth(): void {},
};
